var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8687 2.8688C11.0163 2.71599 11.1928 2.59409 11.3881 2.51024C11.5833 2.42638 11.7932 2.38225 12.0057 2.3804C12.2181 2.37855 12.4288 2.41904 12.6254 2.49949C12.8221 2.57994 13.0007 2.69874 13.1509 2.84897C13.3012 2.9992 13.42 3.17784 13.5004 3.37448C13.5809 3.57111 13.6214 3.7818 13.6195 3.99424C13.6177 4.20669 13.5735 4.41664 13.4897 4.61185C13.4058 4.80706 13.2839 4.98361 13.1311 5.1312L12.4967 5.7656L10.2343 3.5032L10.8687 2.8688ZM9.1031 4.6344L2.3999 11.3376V13.6H4.6623L11.3663 6.8968L9.1031 4.6344Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.37514831cdec09b048ae665994aa4ad7.svg";
export { ForwardRef as ReactComponent };